import { GET_COMPANY_KNOWLEDGE_GUIDE, GET_COMPANY_KNOWLEDGE_GUIDE_FAILED, GET_COMPANY_KNOWLEDGE_GUIDE_SUCCESS, GET_KNOWLEDGE_CENTER, GET_KNOWLEDGE_CENTER_FAIL, GET_KNOWLEDGE_CENTER_SUCCESS, GET_KNOWLEDGE_GUIDE_LINKS, GET_KNOWLEDGE_GUIDE_LINKS_FAILED, GET_KNOWLEDGE_GUIDE_LINKS_SUCCESS } from "./constants";

const initialState = {
    Loading: false,
    successMsg: "",
    errors: "",
    knowledgeCenterData: [],
    companyList: [],
    companyWiseLinks: [],
}

const MainKnowledgeCenterReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_KNOWLEDGE_CENTER:
        case GET_COMPANY_KNOWLEDGE_GUIDE:
        case GET_KNOWLEDGE_GUIDE_LINKS:
            return {
                ...state,
                Loading: true,
                errors: "",
                successMsg: ""
            }
        case GET_KNOWLEDGE_CENTER_SUCCESS:
            return {
                ...state,
                Loading: false,
                knowledgeCenterData: action.payload
            }

        case GET_KNOWLEDGE_CENTER_FAIL:
        case GET_COMPANY_KNOWLEDGE_GUIDE_FAILED:
        case GET_KNOWLEDGE_GUIDE_LINKS_FAILED:
            return {
                ...state,
                Loading: true,
                errors: action.payload
            }
        case GET_COMPANY_KNOWLEDGE_GUIDE_SUCCESS:
            return {
                ...state,
                companyList: action.payload,
                loading: false
            }
        case GET_KNOWLEDGE_GUIDE_LINKS_SUCCESS:
            return {
                ...state,
                companyWiseLinks: action.payload,
                loading: false
            }

        default:
            return state
    }
}

export default MainKnowledgeCenterReducer